import { callEndpoint, callEndpointWithPayload } from '../baseApi'

export const GetTopic = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/topics/${uuid}`, 'GET', idToken)
}

export const UpdateTopic = async (uuid, idToken, payload) => {
  return await callEndpointWithPayload(`${process.env.REACT_APP_API}/topics/${uuid}`, 'PATCH', idToken, payload)
}

export const DeleteTopic = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/topics/${uuid}`, 'DELETE', idToken)
}

export const GetTopicContentsList = async (idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/topics_contents_list/`, 'GET', idToken)
}